var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 88,
    viewBox: "0 0 60 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 4,
    r: 4,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.75C25.526 31.755 21.2367 33.5345 18.0731 36.6981C14.9095 39.8617 13.13 44.151 13.125 48.625V67.375C13.125 71.8505 14.9029 76.1427 18.0676 79.3074C21.2322 82.4721 25.5245 84.25 30 84.25C34.4755 84.25 38.7677 82.4721 41.9324 79.3074C45.0971 76.1427 46.875 71.8505 46.875 67.375V48.625C46.87 44.151 45.0905 39.8617 41.9269 36.6981C38.7633 33.5345 34.474 31.755 30 31.75ZM43.125 67.375C43.125 70.856 41.7422 74.1944 39.2808 76.6558C36.8194 79.1172 33.481 80.5 30 80.5C26.519 80.5 23.1806 79.1172 20.7192 76.6558C18.2578 74.1944 16.875 70.856 16.875 67.375V48.625C16.875 45.144 18.2578 41.8056 20.7192 39.3442C23.1806 36.8828 26.519 35.5 30 35.5C33.481 35.5 36.8194 36.8828 39.2808 39.3442C41.7422 41.8056 43.125 45.144 43.125 48.625V67.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 43C29.5027 43 29.0258 43.1975 28.6742 43.5492C28.3225 43.9008 28.125 44.3777 28.125 44.875V52.375C28.125 52.8723 28.3225 53.3492 28.6742 53.7008C29.0258 54.0525 29.5027 54.25 30 54.25C30.4973 54.25 30.9742 54.0525 31.3258 53.7008C31.6775 53.3492 31.875 52.8723 31.875 52.375V44.875C31.875 44.3777 31.6775 43.9008 31.3258 43.5492C30.9742 43.1975 30.4973 43 30 43Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownButton);
export default __webpack_public_path__ + "static/media/DownButton.73901fc7f246698eec642bb20461b206.svg";
export { ForwardRef as ReactComponent };